import 'react-chatbot-kit/build/main.css';
import './App.css';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';

import HomePage from "./pages/HomePage";
import LineamientosPage from './pages/LineamientosPage';
import LoginPage from "./pages/LoginPage";
import PeriodicoDigitalPage from "./pages/PeriodicoDigitalPage";
import ReportesPage from "./pages/ReportesPage";
import FabrizzioPage from "./pages/FabrizzioPage";
import { Layout } from "./pages/Layout";
import { SeNicePage } from "./pages/SeNicePage";
import { VestimentaImagenPage } from "./pages/VestimentaImagenPage";
import { CulturaPage } from "./pages/CulturaPage";
import { NormasConductaPage } from "./pages/NormasConductaPage";
import { CapacitacitacionPage } from "./pages/CapacitacitacionPage";
import { ProtocoloServicioPage } from "./pages/ProtocoloServicioPage";
import { Nom035Page } from "./pages/Nom035Page";
import { MarketingPage } from "./pages/MarketingPage";
import { PerifoneosPage } from "./pages/PerifoneosPage";
import { BarkerPage } from "./pages/BarkerPage";
import { FolleteriaDigitalPage } from "./pages/FolleteriaDigitalPage";
import { PuntosVentaPage } from "./pages/PuntosVentaPage";
import { FlyersDigitalesPage } from "./pages/FlyersDigitalesPage";
import { FlyersMarketplacePage } from "./pages/FlyersMarketplacePage";
import { PuntoVenta } from "./components/marketing/PuntoVenta";
import { RoleProtectedRoute } from "./components/RoleProtectedRoute";
import { AdminPage } from "./pages/AdminPage";
import { MatrizPromocionesPage } from "./pages/MatrizPromocionesPage";
import { ProcesosPoliticasPage } from "./pages/ProcesosPoliticasPage";
import { MatrizPromociones } from "./components/marketing/MatrizPromociones";
import { MaterialApoyoPage } from "./pages/MaterialApoyoPage";

import FormularioPublicoDeSolicitudes from "./components/GestionUsuarios/FormularioPublicoDeSolicitud";
import AdminSolicitudes from "./components/GestionUsuarios/PanelDeAprobacion";

import ChatbotComponent from "./components/chatbot/ChatbotComponent";
import ManagerSolicitudes from './components/GestionUsuarios/ManagerSolicitudes';
import RegistroPage from './components/GestionUsuarios/RegistroPage';
import CompletedSolicitudes from './components/GestionUsuarios/CompletedSolicitudes';
import PlantillaSolicitudes from './components/GestionUsuarios/Plantilla';
import SolicitudBaja from './components/GestionUsuarios/SolicitudBaja';
import SolicitudAprovacion from './components/GestionUsuarios/AprobacionBaja';
import BajasEnProceso from './components/GestionUsuarios/BajasProceso';
import SolicitudReactivar from './components/GestionUsuarios/SolicitudReactivar';
import SolicitudModificacionSupervisor from "./components/GestionUsuarios/SupervisorModificaciones";
import SolicitudApruebaSupervisor from "./components/GestionUsuarios/EjecutarModificaciones";
import ImportarSolicitudes from "./pages/ImportarSolicitudes";
import Movimientos from "./components/GestionUsuarios/movimientosSolicitudes";
import GestionBodegas from "./components/GestionUsuarios/GestionBodegas";
import AdminDatabase from "./components/GestionUsuarios/AdminDatabase";
import BlacklistModule from "./components/Blacklist/BlacklistModule";



// Este componente vive dentro del <Router> y por tanto puede usar useLocation()
function AppRoutes() {
  const { pathname } = useLocation();

  return (
    <div className="App">
      <Routes>
        <Route
          path="/"
          element={
            <RoleProtectedRoute allowedRoles={[1, 2, 3, 4, 5, 13, 14]}>
              <Layout>
                <HomePage />
              </Layout>
            </RoleProtectedRoute>
          }
        />

        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/periodico-digital"
          element={
            <RoleProtectedRoute allowedRoles={[1, 2, 3, 4, 5, 13, 14]}>
              <Layout>
                <PeriodicoDigitalPage />
              </Layout>
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/reportes"
          element={
            <RoleProtectedRoute allowedRoles={[1, 2, 3, 13, 14]}>
              <Layout>
                <ReportesPage />
              </Layout>
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/mercadotecnia"
          element={
            <RoleProtectedRoute allowedRoles={[1, 2, 3, 4, 13, 14]}>
              <Layout>
                <MarketingPage />
              </Layout>
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/mercadotecnia/matriz-de-promociones"
          element={
            <RoleProtectedRoute allowedRoles={[1, 2, 3, 4, 5, 13, 14]}>
              <Layout>
                <MatrizPromocionesPage />
              </Layout>
            </RoleProtectedRoute>
          }
        />
        <Route
          path="matriz-de-promociones/:marca"
          element={
            <RoleProtectedRoute allowedRoles={[1, 2, 3, 5, 4, 13, 14]}>
              <Layout>
                <MatrizPromociones />
              </Layout>
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/mercadotecnia/perifoneos"
          element={
            <RoleProtectedRoute allowedRoles={[1, 2, 3, 4, 5, 13, 14]}>
              <Layout>
                <PerifoneosPage />
              </Layout>
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/mercadotecnia/barker"
          element={
            <RoleProtectedRoute allowedRoles={[1, 2, 3, 5, 4, 13, 14]}>
              <Layout>
                <BarkerPage />
              </Layout>
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/mercadotecnia/folleteria-digital"
          element={
            <RoleProtectedRoute allowedRoles={[1, 2, 3, 5, 4, 13, 14]}>
              <Layout>
                <FolleteriaDigitalPage />
              </Layout>
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/mercadotecnia/flyers-digitales"
          element={
            <RoleProtectedRoute allowedRoles={[1, 2, 3, 5, 4, 13, 14]}>
              <Layout>
                <FlyersDigitalesPage />
              </Layout>
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/mercadotecnia/flyers-marketplace"
          element={
            <RoleProtectedRoute allowedRoles={[1, 2, 3, 4, 5, 13, 14]}>
              <Layout>
                <FlyersMarketplacePage />
              </Layout>
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/mercadotecnia/material-de-apoyo"
          element={
            <RoleProtectedRoute allowedRoles={[1, 2, 3, 4, 5, 13, 14]}>
              <Layout>
                <MaterialApoyoPage />
              </Layout>
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/mercadotecnia/puntos-de-venta"
          element={
            <RoleProtectedRoute allowedRoles={[1, 2, 3, 4, 5, 13, 14]}>
              <Layout>
                <PuntosVentaPage />
              </Layout>
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/punto-venta/:estado"
          element={
            <RoleProtectedRoute allowedRoles={[1, 2, 3, 4, 5, 13, 14]}>
              <Layout>
                <PuntoVenta />
              </Layout>
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/Fabrizzio"
          element={
            <RoleProtectedRoute allowedRoles={[1]}>
              <Layout>
                <FabrizzioPage />
              </Layout>
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/lineamientos"
          element={
            <RoleProtectedRoute allowedRoles={[1, 2, 3, 4, 13, 14]}>
              <Layout>
                <LineamientosPage />
              </Layout>
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/lineamientos/se-nice"
          element={
            <RoleProtectedRoute allowedRoles={[1, 2, 3, 4, 13, 14]}>
              <Layout>
                <SeNicePage />
              </Layout>
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/lineamientos/codigo-vestimenta"
          element={
            <RoleProtectedRoute allowedRoles={[1, 2, 3, 4, 13, 14]}>
              <Layout>
                <VestimentaImagenPage />
              </Layout>
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/lineamientos/cultura"
          element={
            <RoleProtectedRoute allowedRoles={[1, 2, 3, 4, 13, 14]}>
              <Layout>
                <CulturaPage />
              </Layout>
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/lineamientos/normas-conducta"
          element={
            <RoleProtectedRoute allowedRoles={[1, 2, 3, 4, 13, 14]}>
              <Layout>
                <NormasConductaPage />
              </Layout>
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/lineamientos/capacitacion"
          element={
            <RoleProtectedRoute allowedRoles={[1, 2, 3, 4, 13, 14]}>
              <Layout>
                <CapacitacitacionPage />
              </Layout>
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/lineamientos/procesos-politicas"
          element={
            <RoleProtectedRoute allowedRoles={[1, 2, 3, 4, 13, 14]}>
              <Layout>
                <ProcesosPoliticasPage />
              </Layout>
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/lineamientos/protocolos-servicio"
          element={
            <RoleProtectedRoute allowedRoles={[1, 2, 3, 4, 13, 14]}>
              <Layout>
                <ProtocoloServicioPage />
              </Layout>
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/lineamientos/nom-035"
          element={
            <RoleProtectedRoute allowedRoles={[1, 2, 3, 13, 14]}>
              <Layout>
                <Nom035Page />
              </Layout>
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <RoleProtectedRoute allowedRoles={[1, 13, 14]}>
              <Layout>
                <AdminPage />
              </Layout>
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/solicitudes"
          element={
            <RoleProtectedRoute allowedRoles={[1, 2, 3, 14]}>
              <Layout>
                <AdminSolicitudes />
              </Layout>
            </RoleProtectedRoute>
          }
        />

        <Route
          path="/solicitudes-proceso"
          element={
            <RoleProtectedRoute allowedRoles={[1, 2, 3, 14]}>
              <Layout>
                <ManagerSolicitudes />
              </Layout>
            </RoleProtectedRoute>
          }
        />

        <Route
          path="/solicitar-usuario"
          element={
            <RoleProtectedRoute allowedRoles={[1, 4, 14]}>
              <Layout>
                <FormularioPublicoDeSolicitudes />
              </Layout>
            </RoleProtectedRoute>
          }
        />

        <Route
          path="/registro"
          element={
            <RoleProtectedRoute allowedRoles={[1, 14]}>
              <Layout>
                <RegistroPage />
              </Layout>
            </RoleProtectedRoute>
          }
        />

        <Route
          path="/completas"
          element={
            <RoleProtectedRoute allowedRoles={[1, 4, 14]}>
              <Layout>
                <CompletedSolicitudes />
              </Layout>
            </RoleProtectedRoute>
          }
        />

        <Route
          path="/plantilla"
          element={
            //<RoleProtectedRoute allowedRoles={[1, 3, 14]}>
            <RoleProtectedRoute allowedRoles={[1, 2, 3, 4, 14]}>
              <Layout>
                <PlantillaSolicitudes />
              </Layout>
            </RoleProtectedRoute>
          }
        />

        <Route
          path="/solicitud-baja"
          element={
            <RoleProtectedRoute allowedRoles={[3, 4]}>
              <Layout>
                <SolicitudBaja />
              </Layout>
            </RoleProtectedRoute>
          }
        />

        <Route
          path="/solicitud-aprobacion"
          element={
            <RoleProtectedRoute allowedRoles={[1, 2, 3, 14]}>
              <Layout>
                <SolicitudAprovacion />
              </Layout>
            </RoleProtectedRoute>
          }
        />

        <Route
          path="/baja-proceso"
          element={
            <RoleProtectedRoute allowedRoles={[1, 2, 3, 14]}>
              <Layout>
                <BajasEnProceso />
              </Layout>
            </RoleProtectedRoute>
          }
        />

          <Route
          path="/AprobacionBaja"
          element={
            <RoleProtectedRoute allowedRoles={[1, 14]}>
              <Layout>
                <SolicitudAprovacion />
              </Layout>
            </RoleProtectedRoute>
          }
        />

        <Route
          path="/solicitud-modificacion-supervisor"
          element={
            <RoleProtectedRoute allowedRoles={[2, 3]}>
              <Layout>
                <SolicitudModificacionSupervisor />
              </Layout>
            </RoleProtectedRoute>
          }
        />
        <Route path="/solicitud-reactivar" element={
            <RoleProtectedRoute allowedRoles={[1, 2, 3, 14]}>
              <Layout><SolicitudReactivar /></Layout>
            </RoleProtectedRoute>
          }
        />

        <Route
          path="/aprueba-modificacion-supervisor"
          element={
            <RoleProtectedRoute allowedRoles={[1, 14]}>
              <Layout>
                <SolicitudApruebaSupervisor />
              </Layout>
            </RoleProtectedRoute>
          }
        />
          <Route
              path="/importar"
              element={
                  <RoleProtectedRoute allowedRoles={[1, 14]}>
                      <Layout>
                          <ImportarSolicitudes />
                      </Layout>
                  </RoleProtectedRoute>
              }
          />

        <Route
          path="/movimientos-solicitudes"
          element={
            <RoleProtectedRoute allowedRoles={[1, 2, 14]}>
              <Layout>
                <Movimientos/>
              </Layout>
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/gestion-bodegas"
          element={
            <RoleProtectedRoute allowedRoles={[1, 14]}>
              <Layout>
                <GestionBodegas />
              </Layout>
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/admin-database"
          element={
            <RoleProtectedRoute allowedRoles={[1]}>
              <Layout>
                <AdminDatabase />
              </Layout>
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/blacklist"
          element={
            <RoleProtectedRoute allowedRoles={[1, 14, 8, 4]}>
              <Layout>
                <BlacklistModule />
              </Layout>
            </RoleProtectedRoute>
          }
        />

      </Routes>

      {/* Solo renderiza el chat si NO estamos en /solicitar-usuario */}
      {pathname !== "/solicitar-usuario" && <ChatbotComponent />}
    </div>
  );
}

export default function App() {
  return (
    <Router>
      <AppRoutes/>
    </Router>
  );
}